import {
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  useMediaQuery
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import Pagination from "components/shared/Pagination";
import useCatalog from "hooks/useCatalog";
import Row from "./TableRow";

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    borderCollapse: 'separate',
    [theme.breakpoints.down(420)]: {
      display: 'block',
      '& .MuiTableBody-root': { display: 'block'}
    }
  },
  header: {
    backgroundColor: 'inherit',
    height: 32,
    '& > th.MuiTableCell-head': {
      padding: theme.spacing(0, 3, 0, 2),
      fontSize: 12,
      lineHeight: '18px',
      letterSpacing: 0.5,
      fontWeight: 600,
      borderBottom: 'none',
      [theme.breakpoints.down(420)]: { paddingLeft: theme.spacing(2)}
    },
  },
  srOnly: { visibility: 'hidden'},
  xxsLoading: { display: 'block', width: '100%'},
  xxsContainer: { overflowX: 'visible'}
}));

const CatalogTable = () => {
  const { currentPage, loading, rowsData, totalCount, setCurrentPage } =
    useCatalog();
  const classes = useStyles();
  const isXXS = useMediaQuery((theme: Theme) => theme.breakpoints.down(420));
  
  return (
    <>
      <TableContainer className={isXXS? classes.xxsContainer : undefined}>
        <Table size="small" className={classes.table}>
          <TableHead>
            <TableRow className={classes.header}>
              <TableCell>Design</TableCell>
              <TableCell>
                <span className={isXXS? classes.srOnly : undefined}>
                  Design Type
                </span>
              </TableCell>
              <TableCell>
                <span className={isXXS? classes.srOnly : undefined}>
                  Reads
                </span>
              </TableCell>
              <TableCell>
                <span className={isXXS? classes.srOnly : undefined}>
                  Genes
                </span>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading && (
              <TableRow className={isXXS? classes.xxsLoading : undefined}>
                <TableCell colSpan={6} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            )}
            {!loading && rowsData.map((row) => <Row key={row.id} row={row} />)}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        totalCount={totalCount}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </>
  );
};

export default CatalogTable;
